import React, {Component} from 'react';
import { Context } from "context";

import styles from 'components/blackout/blackout.module.scss';
import isMobile from "ismobilejs";

/**
 * Message Banner component
 * @param {Object} props
 */
export default class Blackout extends Component {
    static contextType = Context;

    stopClicks = event => {
        if(event.path){
            const eventSourceIsConfirmationToast = event.path.some(elem => elem?.classList?.contains("confirm"));

            if (!eventSourceIsConfirmationToast){
                event.stopPropagation();
                event.preventDefault();
            }
        }
    };

    render() {
        const shouldDisplay = this.context.toasts.some(toast => toast.type === "confirm") || !this.context.networkConnected;

        if (shouldDisplay){
            window.addEventListener("click", this.stopClicks, true)
        } else {
            window.removeEventListener("click", this.stopClicks, true);
        }

        if (isMobile().any) return null;

        return (
            <div className={`${shouldDisplay ? "blackout" : ""} ${styles.blackout}`}></div>
        )
    }
}